// Copyright © 2022 Olo Inc. All rights reserved.
// This software is made available under the Olo Pay SDK License (See LICENSE.md file)
import { WebPlugin } from '@capacitor/core';

import type { 
  ChangeGooglePayVendorOptions, 
  DigitalWalletStatus, 
  GooglePayInitializationOptions, 
  DigitalWalletPaymentMethodResult, 
  GooglePayPaymentRequestOptions, 
  AndroidInitializationOptions,
  iOSInitializationOptions,
  OloPaySDKPlugin,
  InternalInitOptions,
  InitializationStatus} from './definitions';
import {
  PromiseRejectionCode
} from './definitions';

// NOTE: This web interface is required by the Capacitor Plugin, but it will not do anything
export class OloPaySDKWeb extends WebPlugin implements OloPaySDKPlugin {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async initializeGooglePay(_options: GooglePayInitializationOptions): Promise<void> {
    return Promise.reject({
      code: PromiseRejectionCode.uninmplemented.toString(),
      message: 'initializeGooglePay() is not implemented for web'
    });
  }
  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async changeGooglePayVendor(_options: ChangeGooglePayVendorOptions): Promise<void> {
    return Promise.reject({
      code: PromiseRejectionCode.uninmplemented.toString(),
      message: 'changeGooglePayVendor() is not implemented for web'
    });
  }
  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async isDigitalWalletReady(): Promise<DigitalWalletStatus> {
    return Promise.reject({
      code: PromiseRejectionCode.uninmplemented.toString(),
      message: 'isDigitalWalletReady() is not implemented for web'
    });
  }
  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async getDigitalWalletPaymentMethod(_options: GooglePayPaymentRequestOptions): Promise<DigitalWalletPaymentMethodResult | undefined> {
    return Promise.reject({
      code: PromiseRejectionCode.uninmplemented.toString(),
      message: 'getDigitalWalletPaymentMethod() is not implemented for web'
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async initialize(_options: AndroidInitializationOptions | iOSInitializationOptions): Promise<void> { 
    return Promise.reject({
      code: PromiseRejectionCode.uninmplemented.toString(),
      message: 'initialize() is not implemented for web'
    });
  }

  isInitialized(): Promise<InitializationStatus> {
    return Promise.reject({
      code: PromiseRejectionCode.uninmplemented.toString(),
      message: 'isInitialized() is not implemented for web'
    });
  }
  isDigitalWalletInitialized(): Promise<InitializationStatus> {
    return Promise.reject({
      code: PromiseRejectionCode.uninmplemented.toString(),
      message: 'isDigitalWalletInitialized() is not implemented for web'
    });
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  initializeInternal(_options: InternalInitOptions): Promise<void> {
    return Promise.reject({
      code: PromiseRejectionCode.uninmplemented.toString(),
      message: 'isDigitalWalletInitialized() is not implemented for web'
    });
  }
}
